import { useEffect, useState } from 'react';
import useModal from '../../../hooks/useModal';
import ModalContainer from '../../Modal/ModalContainer';
import PaymentMethod from './PaymentMethod';
import AddPaymentMethod from '../../Modal/AddPaymentMethod';
import { useAuthContext } from '../../../hooks/useAuthContext';

function PaymentMethods() {
  const {auth} = useAuthContext();
  const [paymentMethods, setPaymentMethods] = useState([]);

  useEffect(() => {
    if (auth?.user.bankInfo) {
      setPaymentMethods(prevMethods => {
        
     

          return [
            {
              id: auth.user._id,
              name: "تحويل بنكي",
              description: "يتم تحويل الراتب مباشرة إلى حسابك المصرفي.",
              image: "https://cdn.iconscout.com/icon/free/png-512/bank-transfer-1817143-1538011.png",
              available: true,
              default: false,
              requirements: [
                { field: "اسم البنك", example: auth.user.bankInfo.bankName },
                { field: "اسم صاحب الحساب", example: auth.user.bankInfo.accountName },
                { field: "رقم الحساب", example: auth.user.bankInfo.accountNumber },
                { field: "الآيبان", example: auth.user.bankInfo.iban },
                { field: "رمز SWIFT/BIC", example: auth.user.bankInfo.swiftCode },
              ]
            }
          ];
      });
    }
  }, [auth]);
  

  console.log(paymentMethods);
  
  
  
  
  const { modalOpen, close, open } = useModal();

  return (
    <div className="df-c">
      <ModalContainer>
        {modalOpen && (
          <AddPaymentMethod
            modalOpen={modalOpen}
            handleClose={close}
          />
        )}
      </ModalContainer>
      {auth && !auth.user.bankInfo && <div className="details-btn w-fit" onClick={open}>إضافة  bank info</div>}

      <div className='df-c'>
        <div className="df w-full jc-sb">

            <div className="df w-4/6">
        <img
          src="/img/cash.jpg"
          alt="نقدًا"
          style={{ width: "90px", height: "90px", borderRadius: "7px" }}
        />
        <div className="df-c !gap-1">
          <div className="title">نقدًا</div>
          <div className="text text-xs">تلقي الراتب نقدًا مباشرةً من الشركة</div>
        </div>
      </div>
      <div
        className={`payment-status text-center text-xs default`}
      >
         
         خيار افتراضي
      </div>
        </div>
        {paymentMethods.map((method) => (
          <div key={method.id} className={`payment-m`}>
            <PaymentMethod method={method}/>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PaymentMethods;
